import { render, staticRenderFns } from "./ArSplitTable.vue?vue&type=template&id=24763a0d"
import script from "./ArSplitTable.vue?vue&type=script&lang=js"
export * from "./ArSplitTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports